import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CreateProblemReportRequest, ProblemReportCreated, ReportAttachment } from 'src/app/global/components/dialogs/report-problem-dialog/report-problem.model';
import { environment } from 'src/environments/environment';
import { ReportProblemService } from './report-problem.abstract.service';

@Injectable({
    providedIn: 'root',
})
export class ReportProblemImplService implements ReportProblemService {
    private baseUrl: string = environment.API_GATEWAY_URL;

    constructor(@Inject('HTTP_CLIENT') public http: HttpClient) {}

    /** Same temporary upload as request files (UserService.postDocuments), one file per call. */
    uploadAttachment(file: File): Observable<ReportAttachment> {
        const formData = new FormData();
        formData.append('file', file);
        return this.http.post<string[]>(`${this.baseUrl}/requests/fileupload/temp`, formData).pipe(
            map((urls) => {
                if (!urls?.length) {
                    throw new Error('Empty upload response');
                }
                return { url: urls[0], originalName: file.name };
            }),
        );
    }

    create(report: CreateProblemReportRequest): Observable<ProblemReportCreated> {
        return this.http.post<ProblemReportCreated>(`${this.baseUrl}/organisations/admin/problem-reports`, report);
    }
}

export const REPORT_PROBLEM_SERVICE_PROVIDER = {
    provide: ReportProblemService,
    useClass: ReportProblemImplService,
};
